(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  class OAHeaderCartMenu extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.panel = this.querySelector('.oa-header-cart-menu__panel');
      this.preview = this.querySelector('[data-cart-preview]');
      this.empty = this.querySelector('.oa-header-cart-menu__empty');
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.handleKeyUp = this.handleKeyUp.bind(this);
      this.handleToggle = this.handleToggle.bind(this);

      document.addEventListener('click', this.handleDocumentClick);
      document.addEventListener('keyup', this.handleKeyUp);
      this.details?.addEventListener('toggle', this.handleToggle);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleDocumentClick);
      document.removeEventListener('keyup', this.handleKeyUp);
      this.details?.removeEventListener('toggle', this.handleToggle);
    }

    async handleToggle() {
      if (!this.details?.open || !this.panel?.dataset.cartUrl) return;

      try {
        const response = await fetch(this.panel.dataset.cartUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        this.render(await response.json());
      } catch (error) {
        return;
      }
    }

    render(cart) {
      const hasItems = Array.isArray(cart.items) && cart.items.length > 0;
      this.empty.hidden = hasItems;
      this.preview.hidden = !hasItems;
      this.preview.replaceChildren();

      if (!hasItems) return;

      cart.items.forEach((item) => {
        const link = document.createElement('a');
        link.className = 'oa-header-cart-menu__item';
        link.href = item.url;

        const media = document.createElement('span');
        media.className = 'oa-header-cart-menu__media';
        if (item.image) {
          const image = document.createElement('img');
          image.src = `${item.image}${item.image.includes('?') ? '&' : '?'}width=112`;
          image.alt = item.product_title;
          image.width = 56;
          image.height = 56;
          image.loading = 'lazy';
          media.append(image);
        }

        const details = document.createElement('span');
        details.className = 'oa-header-cart-menu__details';
        const title = document.createElement('strong');
        title.textContent = item.product_title;
        details.append(title);

        if (item.variant_title) {
          const variant = document.createElement('small');
          variant.textContent = item.variant_title;
          details.append(variant);
        }

        const meta = document.createElement('small');
        const price = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: cart.currency || 'USD',
        }).format(item.final_line_price / 100);
        meta.textContent = `QTY ${item.quantity} · ${price}`;
        details.append(meta);
        link.append(media, details);
        this.preview.append(link);
      });
    }

    handleDocumentClick(event) {
      if (this.details?.open && !this.contains(event.target)) this.close();
    }

    handleKeyUp(event) {
      if (event.code === 'Escape' && this.details?.open) {
        this.close();
        this.summary?.focus();
      }
    }

    close() {
      this.details?.removeAttribute('open');
    }
  }

  if (!customElements.get('oa-cart-menu')) customElements.define('oa-cart-menu', OAHeaderCartMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orthodox-red-archive"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oa-release-link')) {
    customElements.define('oa-release-link', class extends HTMLElement {
      connectedCallback() {
        this.deadline = Date.parse(this.dataset.deadline);
        if (!Number.isFinite(this.deadline)) return;
        this.releaseLink = this.closest('.oa-red-release').querySelector('.oa-red-release__shop');
        this.checkRelease = async () => {
          if (!this.isConnected || Date.now() < this.deadline) return;
          try {
            const response = await fetch(this.releaseLink.href + '.js', { cache: 'no-store' });
            const product = response.ok ? await response.json() : null;
            if (product && product.handle === 'orthodox-red-cap') {
              if (!this.isConnected) return;
              this.releaseLink.hidden = false;
              this.closest('.oa-red-release').classList.add('is-unlocked');
              this.closest('.oa-red-release').querySelector('.oa-cap-unlock__status').textContent = product.available ? this.dataset.unlocked : this.dataset.soldOut;
              this.closest('.oa-red-release').querySelector('.orthodox-window-bar strong').textContent = this.dataset.brand;
              if (!product.available) this.releaseLink.textContent = this.dataset.view;
              const locked = this.closest('.oa-red-release').querySelector('.oa-red-release__locked');
              if (locked) locked.hidden = true;
              return;
            }
          } catch {}
          if (this.isConnected) this.releaseRetry = setTimeout(this.checkRelease, 15000);
        };
        this.tick = () => {
          const remaining = this.deadline - Date.now();
          if (remaining <= 0) {
            this.checkRelease();
          } else {
            this.timer = setTimeout(this.tick, Math.min(remaining, 2147483647));
          }
        };
        this.tick();
      }
      disconnectedCallback() { clearTimeout(this.timer); clearTimeout(this.releaseRetry); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
